import { useEffect, useState } from "react";

const MIN_MS = 5000;
const MAX_MS = 10000;

function randomDelayMs(): number {
    return MIN_MS + Math.floor(Math.random() * (MAX_MS - MIN_MS + 1));
}

/**
 * Incrementa `tick` ogni 5–10s (random per ciclo), indipendente per ogni istanza.
 * Disattivare con `enabled: false` (es. prefers-reduced-motion).
 * In tab non visibile non incrementa; riprende quando la pagina torna visibile.
 */
export function useMockRefreshTick(enabled: boolean): number {
    const [tick, setTick] = useState(0);

    useEffect(() => {
        if (!enabled) return;

        let cancelled = false;
        let timeoutId: number | NodeJS.Timeout | undefined;

        const scheduleNext = () => {
            if (cancelled) return;
            const delay =
                typeof document !== "undefined" && document.visibilityState !== "visible" ? 1000 : randomDelayMs();
            timeoutId = window.setTimeout(() => {
                if (cancelled) return;
                if (typeof document !== "undefined" && document.visibilityState === "visible") {
                    setTick((t) => t + 1);
                }
                scheduleNext();
            }, delay);
        };

        scheduleNext();

        return () => {
            cancelled = true;
            if (timeoutId !== undefined) {
                window.clearTimeout(timeoutId);
            }
        };
    }, [enabled]);

    return tick;
}
